// GET DOCUMENT TYPES
export const GET_DOCUMENT_TYPES_MASTER_REQUEST = 'GET_DOCUMENT_TYPES_REQUEST';
export const GET_DOCUMENT_TYPES_MASTER_SUCCESS = 'GET_DOCUMENT_TYPES_SUCCESS';
export const GET_DOCUMENT_TYPES_MASTER_FAILURE = 'GET_DOCUMENT_TYPES_FAILURE';

// SAVE
export const SAVE_DOCUMENT_TYPE_REQUEST = 'SAVE_DOCUMENT_TYPE_REQUEST';
export const SAVE_DOCUMENT_TYPE_SUCCESS = 'SAVE_DOCUMENT_TYPE_SUCCESS';
export const SAVE_DOCUMENT_TYPE_FAILURE = 'SAVE_DOCUMENT_TYPE_FAILURE';

// DELETE
export const DELETE_DOCUMENT_TYPE_REQUEST = 'DELETE_DOCUMENT_TYPE_REQUEST';
export const DELETE_DOCUMENT_TYPE_SUCCESS = 'DELETE_DOCUMENT_TYPE_SUCCESS';
export const DELETE_DOCUMENT_TYPE_FAILURE = 'DELETE_DOCUMENT_TYPE_FAILURE';

// GET BY ID
export const GET_DOCUMENT_TYPE_BY_ID_REQUEST = 'GET_DOCUMENT_TYPE_BY_ID_REQUEST';
export const GET_DOCUMENT_TYPE_BY_ID_SUCCESS = 'GET_DOCUMENT_TYPE_BY_ID_SUCCESS';
export const GET_DOCUMENT_TYPE_BY_ID_FAILURE = 'GET_DOCUMENT_TYPE_BY_ID_FAILURE';





